__turbopack_context__.v({
  "accordionButton": "styles-module__rLtguW__accordionButton",
  "container": "styles-module__rLtguW__container",
  "content": "styles-module__rLtguW__content",
});
